const home = {
    carousel: {
        concert: {
            title: "Latest Music Concerts",
            subtitle: "Listen to live music with your favorite singer/group bands"
        }
    }
}

export default home